import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ContractPathsEnum } from 'modules/contractsPage/routes';
import { PageWithHeader } from '../../../ui';

import { Navigation, NavigationType } from '../../../ui/navigation';

import { ContractsOverviewKeys, getContractsOverviewPageUrl } from './helper';
import { getContractsOverviewTabs } from './getTabs';
import { StyledNavigationFlex } from './styled';

export interface ContractsOverviewPageProps {
  number: string;
  tab: string;
}

export const ContractsOverviewPage: FC<ContractsOverviewPageProps> = ({
  number,
  tab,
}) => {
  const { t } = useTranslation();

  const ActiveTabForm = useMemo(
    () =>
      getContractsOverviewTabs(t, number).find(
        (tabForm) => tabForm.key === tab,
      ),
    [t, number, tab],
  );

  return (
    <>
      <PageWithHeader
        title={t('contractOverview.layout.contractOverview')}
        breadcrumbs={[
          {
            text: t('contractOverview.contracts'),
            url: ContractPathsEnum.contracts,
          },
          {
            text: t('contractOverview.layout.contractOverview'),
            url: '',
          },
        ]}>
        <StyledNavigationFlex>
          <Navigation
            type={NavigationType.Tabs}
            activeTab={tab}
            options={[
              {
                label: t('contractOverview.layout.contractDetails'),
                url: getContractsOverviewPageUrl(
                  number,
                  ContractsOverviewKeys.Details,
                ),
              },
              // FRON-514 commented for release day
              // {
              //   label: t('contractOverview.layout.repaymentPlan'),
              //   url: getContractsOverviewPageUrl(
              //     ContractsOverviewKeys.RepaymentPlan,
              //   ),
              // },
              {
                label: t('contractOverview.layout.facilityInformation'),
                url: getContractsOverviewPageUrl(
                  number,
                  ContractsOverviewKeys.FacilityInformation,
                ),
              },
            ]}
            title={t('navigation.menu')}
          />
        </StyledNavigationFlex>
        {ActiveTabForm?.component}
      </PageWithHeader>
    </>
  );
};
